import React, { ReactNode } from "react";
import SwiperCore from "swiper";
import { Swiper, SwiperProps } from "swiper/react";
import "swiper/swiper-bundle.css";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
SwiperCore.use([Navigation, Autoplay]);

interface SliderProps extends SwiperProps {
  children: ReactNode;
}
export const Slider: React.FC<SliderProps> = ({ children, ...swiperProps }) => {
  return (
    <div className="carousel-container">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        /*           autoplay={{
            delay: 4000,
            disableOnInteraction: true,
          }} */
        breakpoints={{
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        }}
        style={{ padding: 20 }}
        {...swiperProps}
      >
        {children}
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </Swiper>
    </div>
  );
};
